module.exports = __webpack_public_path__ + "img/layer-group.40ede42c.svg";